<div class="app-container">
  <app-side-bar
    [sidebarState]="stateService.sidebarState$()"
    [contents]="stateService.sideBarContent$()"
  />
  <div class="content">
    <router-outlet></router-outlet>
    <app-footer />
    <app-spinner />
  </div>
</div>

<app-toast />
